import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';

export const AnnouncementMessage = ({
  formattedCreatedAt,
  announcementFormatted,
}) => (
  <div className={styles.message}>
    <span className={styles.posted}>{formattedCreatedAt}</span>
    <div
      className={styles.messageBody}
      dangerouslySetInnerHTML={announcementFormatted}
    />
  </div>
);

export default enhance(AnnouncementMessage);
